import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Button from 'components/form/Button.component';
import H from 'constants/httpMethod.const';
import useAfn from 'hooks/useAfn.hook';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import endpoint from 'utils/backend/endpoint.util';
import fromBeToBody from 'utils/converters/backend/fromBeToBody.util';
import nullBind from 'utils/functions/nullBind.util';
import logger from 'utils/logger.util';
import actionBe from 'utils/mw/actionBe.util';

const L = logger('MiddlewarePage');

const beListSalons = actionBe('beListSalons', ({ AT, ATAG }) => endpoint(H.get, 'salon/v2/list/', { AT, name: ATAG }));
const beFailCall = actionBe('beListSalons', ({ AT, ATAG }) => endpoint(H.get, 'salon/v2/list', { AT, name: ATAG }));

const fromResultToErrorMessage = nullBind(getAnyOrVoid, 'error.message');

const MiddlewarePage = ({ beListSalons, beFailCall }) => {
  const [listResult, handleList] = useAfn(async () => L.debug('handleList()', await beListSalons()), [beListSalons]);
  const [failResult, handleFail] = useAfn(async () => L.debug('handleFail()', await beFailCall()), [beFailCall]);

  const listMessage = fromResultToErrorMessage(listResult);
  const failMessage = fromResultToErrorMessage(failResult);

  const listBody = fromBeToBody(listResult.value);
  const failBody = fromBeToBody(failResult.value);

  L.debug('()', { listResult, failResult, listMessage, failMessage, listBody, failBody });

  return (
    <div data-bem="MiddlewarePage">
      <Button onClick={handleList}>List</Button>
      <p>{listMessage}</p>

      <Button onClick={handleFail}>Fail</Button>
      <p>{failMessage}</p>

      <p>
        {String(listResult.isLoading)} {String(listResult.isLoaded)}
      </p>
      <textarea value={JSON.stringify(listResult.value, null, 2)} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ beFailCall }, dispatch),
  beListSalons: (...args) => dispatch(beListSalons(...args)),
});

// noinspection JSUnusedGlobalSymbols
const MiddlewarePageHoc = connect(null, mapDispatchToProps)(MiddlewarePage);

export default MiddlewarePageHoc;
